export default {
  Login: {
    Signin: 'Sign in',
    Title: 'Please enter your sign in details',
    UserName: 'Username',
    Password: 'Password',
    UserNameEmpty: 'Username cannot be blank.',
    PasswordEmpty: 'Password cannot be blank.',
    InvalidLogin: 'Username of password incorrect.',
    Error: 'Something went wrong, please try again!',
  },

  Account: {
    Admin: 'Admin',
    SystemManager: 'System Manager',
    Partner: 'Partner Manager',
    Sales: 'Sales Person',
    PartnerSales: 'Partner Sales',
  },

  ChangePassword: {
    Title: 'Change Password',
    UserName: 'Username',
    NewPassword: 'New password',
    PasswordEmpty: 'Password cannot be blank.',
    ConfirmPassword: 'Confirm new new password',
    InvalidPassword:
      'Password must have 8 to 130 letters and contain at least one (1) lowercase letter, one (1) uppercase letter, one (1) symbol and one (1) number.',
    DidMatchPassword: 'The confirmation password does not match',
    ChangedNotify:
      'Password has changed. Please re-login with your new password.',
    UpdateSuccess: 'Update success.',
    UpdateFail: 'Update failed.',
  },

  Register: {
    RegisterLicense: 'Register Licenses',
    Country: 'Country',
    Partner: 'Partner',
    RestaurantName: 'Restaurant name',
    Domain: 'Domain',
    PhoneNumber: 'Phone number',
    Email: 'Email',
    Address: 'Address',
    RegisterMode: 'Mode',
    Version: 'Version',
    VersionRequired: 'Must not be empty',
    ZipCode: 'Zip code',
    MerchantID: 'MID',
    AutoRenew: 'Auto renew',
    AutoRenewNote: 'Auto renew will run on end date.',
    ExtraInfo: 'Extra information',
    SalesPerson: 'Salesperson',
    SalesPersonEmail: "Salesperson's email",
    Cancel: 'Cancel',
    Save: 'Save',
    Confirm: 'Confirm?',
    ConfirmText: 'Are you sure you want to create this license?',
    CreateLicense: 'Create License',
    Reject: 'Reject',
    RejectRequest: 'Reject Request',
    RejectText: 'Are you sure you want to reject this request?',
    RejectPlaceholder: 'Enter reason to reject...',
    InvalidDomain: 'Domain already exists.',
    ValidDomain: 'Domain is valid.',
    Blank: '{0} cannot be blank.',
    Invalid: '{0} invalid',
    Exists: '{0} already exists',
    InvalidCharater: 'Domain cannot contain special characters',
    Registed: 'Restaurant has been registed. Please check again.',
    Success: 'Successfully',
    WarningError: 'Error occurred. Please try again.',
    MessageTitle: 'Notification',
  },

  LicenseInfo: {
    Title: 'License Info',
    Country: 'Country',
    RestaurantName: 'Restaurant Name',
    Domain: 'Domain',
    Email: 'Email',
    PhoneNumber: 'Phone Number',
    Package: 'Package',
    NumberBranch: 'Number of Branches',
    EndDate: 'End Date',
    StartDate: 'Start Date',
    CreatedDate: 'Created Date',
    NumberPos: 'Number of POS',
    NumberTablet: 'Number of Tablet/Handhelds',
    NumberKiosk: 'Number of Kiosk',
    NumberPKGPos: 'Number of Packaged POS',
    NumberPKGTablet: 'Number of Packaged Tablet/Handheld',
    NumberPKGKiosk: 'Number of Packaged Kiosk',
    UpgradeHistory: 'Upgrade History',
    UpgradeFrom: 'Upgrade from ',
    ExtendFor: 'Extended for {months} {unit}',
    PurchasePos: 'Purchased {number} POS',
    PurchaseTablet: 'Purchased {number}  Tablets/Handhelds',
    PurchaseKiosk: 'Purchased {number}  Kiosk',
    Until: '{number} until expiration',
    Expired: 'Expired {number} days ago',
    Registed: 'Registed',
    Partner: 'Partner',
    MerchantID: 'MID',
    LicenseCode: 'LicenseCode',
    Mode: 'Mode',
    Version: 'Version',
  },

  UpdateInfo: {
    Title: 'Update Restaurant Information',
    Partner: 'Partner',
    General: 'GENERAL INFORMATION',
    Country: 'Country',
    RestaurantName: 'Restaurant Name',
    PhoneNumber: 'Phone number',
    Email: 'Email',
    Address: 'Address',
    ZipCode: 'Zip code',
    AutoRenew: 'Auto renew',
    AutoRenewNote: 'Auto renew will run on end date.',
    AutoRenewInactive: 'Domain is inactive — cannot enable auto renew',
    ExtraInfo: 'Extras information',
    Salesperson: 'Salesperson',
    SalespersonEmail: 'Salesperson email',
    RepresentativeInfo1: 'Representative information 1',
    RepresentativeInfo2: 'Representative information 2',
    FirstName: 'First name',
    LastName: 'Last name',
    Roles: 'Roles',
    Owner: 'Owner',
    Accountant: 'Accountant',
    Technician: 'Technician',
    Cancel: 'Cancel',
    Save: 'Save',
    Blank: '{0} cannot be blank.',
    Invalid: '{0} invalid',
    Success: 'Update success.',
    Fail: 'Update failed.',
  },

  CreateRequest: {
    Upgrade: 'Upgrade',
    Extend: 'Extend',
    ExtraDevices: 'Extra devices',
    NewBranch: 'New branch',
    LicenseInfo: 'License Info',
    Country: 'Country',
    RestaurantName: 'Restaurant Name',
    Domain: 'Domain',
    Package: 'Package',
    Trial: 'Trial',
    Standard: 'Standard',
    Starter: 'Starter',
    Advance: 'Advance',
    NumberofBranches: 'Number of Branches',
    Promotion: 'Promotion',
    Extramonths: 'Extra months',
    EndDate: 'End Date',
    UntilExpiration: '{number} days until expiration',
    Expiration: 'Expired {number} days ago',
    NumberofPOS: 'Number of POS',
    NumberofTablets: 'Number of Tablets/Handhelds',
    StartDate: 'Start date',
    Duration: 'Duration (months)',
    ExtramonthsInput: 'Extra months',
    Extradevices: 'Extra devices',
    Note: 'Note',
    NotePlaceholder: 'Your note goes here...',
    Currency: 'Currency',
    ConstCurrency: '($) Dollar',
    ExchangeRate: 'Exchange rate (VND)',
    Year: 'year',
    Month: 'month',
    Include: 'include',
    ExtraPOS: '{month}/month for an extra POS',
    ExtraTablet: '{month}/month for an extra Tablet/Handheld',
    PreviousRefund: 'Previous package refund',
    SalesRevenue: 'Sales revenue',
    PromotionPercent: 'Promotion (%)',
    NetSales: 'Net Sales',
    MisaAmount: "MISA's amount",
    ShareRate: 'Share rate (%)',
    MISAAmount: "MISA's amount",
    PartnerAmount: "Partner's amount",
    ExpiryDate: 'Expiry date',
    Cancel: 'Cancel',
    Save: 'Save',
    Approve: 'Approve',
    Success: 'Update success.',
    Fail: 'Update failed.',
    InforPackagePrice: '${month}/month - ${year}/year',
    IncludePackage: 'Include: {pos} POS, {tablet} Tablet',
    PricePos: '${pos} per month for an extra POS',
    PriceTablet: '${tablet} per month for each extra Tablet/Handheld POS',
    IncludePackageHandheld:
      'Include: {pos} POS, {tablet} Tablet, {handheld} Handheld',
    EmptyPackage: 'Package cannot be blank',
    Payment: 'Payment',
    EmptyExchangeRate: 'Exchange rate cannot be blank',
    WarningEmptyExchangeRate: 'Exchange rate cannot be blank',
    WarningEmptySalesRevenue: 'Sales revenue cannot be blank',
    ExtraMonthPartnerWarning: 'Extra months cannot more than 3 months',
    ExtraMonthWarning: 'Extra months cannot more than duration months',
    PartnerCommission: 'Partner Commission ({percent}%)',
    InforDevicesTablet: '{number} Tablets/Handhelds ({duration} months)',
    PriceDevicesTablet: '${price}/device/month',
    InforPackage: '{packname} ({duration} months)',
    PricePackage: '${priceyear}/year & ${pricemonth}/month',
    InforDevicesPOS: '{number} POS ({duration} months)',
    PriceDevicesPOS: '${price}/POS/month',
    Refund: `Previous package refund`,
    RefundRecipt: `{remain} months ({packname} + {pos} POS + {tablet} Tablets/Handhelds)`,
    Devices: 'Devices',
    Reject: 'Reject',

    NotifySave: 'Are you sure you want to extend this license?',
    PurchaseSave: 'Are you sure you want to purchase this license?',
    UpgradeSave: 'Are you sure you want to upgrade this license?',
    NotifyUpdate: 'Are you sure you want to extend this license?',
    PurchaseUpdate: 'Are you sure you want to purchase this license?',
    UpgradeUpdate: 'Are you sure you want to upgrade this license?',
    NotifyNewBranchUpdate: 'Are you sure you want to update this new branch request?',
    ApproveUpdate: 'Are you sure you want to approve this request?',
    ConfirmCreateRequest: 'Are you sure you want to create this request?',
    ConfirmCreateRequestNewLicense: 'Are you sure you want to request new branch?',
    TimeUpdate: 'Last edited: {date}  by {author}',

    // Tiêu đề dialog request
    CreateRequestTitle: 'Create request',
    UpdateRequestTitle: 'Update request',
    ApproveRequestTitle: 'Approve request',
    CreateRequestNewLicenseTitle: 'Create request',

    // Toast theo hành động
    CreateSuccess: 'Create request successfully',
    CreateFail: 'Create request failed',
    UpdateSuccess: 'Update request successfully',
    UpdateFail: 'Update request failed',
    ApproveSuccess: 'Approve request successfully',
    ApproveFail: 'Approve request failed',
    RejectSuccess: 'Reject request successfully',
    RejectFail: 'Reject request failed'
  },
  CreateAccount: {
    CreateAccount: 'Create Account',
    TypesofAccount: 'Types',
    PartnerManager: 'Partner Manager',
    PartnerSales: 'Partner Sales',
    SystemManager: 'System Manager',
    Sales: 'Sales',
    Country: 'Country',
    Partner: 'Partner',
    FullName: 'Full name',
    PhoneNumber: 'Phone number',
    Email: 'Email',
    UserName: 'Username',
    Password: 'Password',
    ConfirmPassword: 'Confirm password',
    SearchMisaID: 'Search MISA ID',
    NoMatching: 'No matching search results',
    Cancel: 'Cancel',
    Save: 'Save',
    Blank: '{name} cannot be blank',
    NotMatch: "{name} doesn't match",
    Invalid: '{name} invalid',
    Exists: '{name} already exists',
    Success: 'Successfully',
    Failed: 'An error occurred, please try again',
    InvalidPassword:
      'Password must have 8 to 130 letters and contain at least one (1) lowercase letter, one (1) uppercase letter, one (1) symbol and one (1) number.',
    Search: 'Search by email or phone number',
    UpdateAccount: 'Update account',
    EmailInvalid: 'Invalid email address.',
    SelectCountryFirst: 'Please select a country first',
    NoPartnersForThisCountry: 'No partners available for this country'
  },

  Filter: {
    Filter: 'Filter',
    Clear: 'Clear',
    Save: 'Save',
    Cancel: 'Cancel',
  },
  Languages: {
    English: 'English (United States)',
    German: 'German',
    Vietnamese: 'Vietnamese',
  },
  Common: {
    Success: 'Successfully',
    Failed: 'An error occurred, please try again',
    Infor: 'Information',
    Save: 'Save',
    Cancel: 'Cancel',
    Ok: 'OK',
    Yes: 'Yes',
    No: 'No',
    Back: 'Back',
    Create: 'Create',
    Text: 'Are you sure you want to create this license?',
    Delete: 'Delete',
    DeleteTilte: 'Delete Account?',
    Require: `Are you sure you want to delete {name} account?`,
    TitleAssociated:
      'The account has associated data, are you sure you want to delete it?',
    BlockedTitle: 'Blocked Account',
    BlockedText:
      'Your account has been blocked. Contact your System Manager for more information.',
    RejectTitle: 'Reject Request',
    RejectDescription: 'Are you sure want to reject this request?',
    RejectReason: 'Enter reason to reject...',
    Reject: 'Reject',
    RejectEmptyReason: 'Reason reject cannot be blank',
    LicenseReject: 'The license has been rejected',
    TicketsDescription: 'Are you sure want to reject this license?',
    EmptyField: '{fieldName} cannot be blank',
  },
  SessionExpired: "Session expired.",
};
